import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { PaymentMethod, PaymentMethodFilters } from '../../../../app/models/PaymentMethod';
import PaymentMethodSwitchChange from '../PaymentMethodSwitchChange';

interface Props {
    paymentMethods: PaymentMethod[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    active?: (id: number, active: boolean) => void;
    filter: PaymentMethodFilters;
    setFilter: (filter: PaymentMethodFilters) => void;
    callbackSuccess: () => void;
}

const PaymentMethodDataTable = ({
    paymentMethods,
    totalRows,
    loading = false,
    edit,
    active,
    filter,
    setFilter,
    callbackSuccess
}: Props) => {
    const columns = [
        {
            name: 'ID',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            width: '80px',
            cell: (row: PaymentMethod) => <span>{row.id ?? '-'}</span>
        },
        {
            name: 'Nombre',
            selector: (row: any) => row.name,
            sortable: true,
            sortField: 'name',
            cell: (row: PaymentMethod) => <span>{row.name}</span>
        },
        {
            name: 'Activo',
            selector: (row: any) => row.is_active,
            sortable: true,
            sortField: 'is_active',
            width: '100px',
            cell: (row: PaymentMethod) => (
                row.id ? (
                    <PaymentMethodSwitchChange
                        checkValue={row.is_active ?? true}
                        paymentMethodId={row.id}
                        callbackSuccess={callbackSuccess}
                    />
                ) : null
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            width: '150px',
            cell: (row: PaymentMethod) => (
                <div className="">
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    {/* Filtros pueden agregarse aquí si es necesario */}
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={paymentMethods}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default PaymentMethodDataTable;
